

export default class CropAndSaveImageRequest  {
	ImgBase?: string = '';
	Path?: string = '';
	Left: number = 0;
	Top: number = 0;
	Width: number = 0;
	Height: number = 0;
	MaxWidth?: number = null;
	MaxHeight?: number = null;
	constructor(obj?: Partial<CropAndSaveImageRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
